import styled from "styled-components"

import { MEDIA_QUERIES } from "@constants"

import Hero from "@components/Hero/Hero"

export const PostHeroCustomerStoryHERO = styled(Hero)`
  margin-bottom: var(--spacing--L);
  padding-top: 0;

  .PostHeroCustomerStoryHero--content {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .Badge {
    margin: 0 auto var(--spacing--XS) auto;
    font-size: var(--font-size--S);
    padding-left: var(--spacing--base-1-25);
    padding-right: var(--spacing--base-1-25);
    font-family: var(--font-family--mono);
  }

  h1 {
    text-align: center;
    margin-left: auto;
    margin-right: auto;
    max-width: 25ch;

    ${MEDIA_QUERIES.XL} {
      width: var(--column--10);
    }
  }

  .Media {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    aspect-ratio: 1.77;
    background: var(--color--clay-100);
    margin-bottom: var(--spacing--M);
  }

  .PostHeroCustomerStoryHero--stats {
    dl {
      div[data-name="company-size"] {
        grid-row: 1 / 2;
        margin-bottom: calc(var(--base-unit)/5);
      }
      
      div[data-name="industry"] {
        grid-row: 2 / 3;
        margin-bottom: calc(var(--base-unit)/5);
      }
      
      div[data-name="features"] {
        grid-row: 3 / 4;
      }
      
      &.grid {
        gap: var(--spacing--M);
      }

      ${MEDIA_QUERIES.M} {
        div[data-name="industry"] {
          grid-row: 1 / 2;
        }
        div[data-name="features"] {
          grid-row: 2 / 3;
          justify-content: space-between;
        }
      }

      ${MEDIA_QUERIES.L} {
        &.grid {
          display: flex;
          justify-content: center;
        }
      }
    }
    
    div {
      border-left: 1.5px solid var(--color--clay-200);
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: stretch;
    }
    
    dd {
      padding-left: 0;
    }
  }
`

